import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Settings from "@mui/icons-material/Settings";
import KeyIcon from "@mui/icons-material/Key";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/MoreVert";

export default function LongMenu({
  rowData,
  openDialogResetPassword,
  openDialog,
  navigationLink,
  isGroupMenu,
}) {
  const [anchorE2, setAnchorE2] = React.useState(null);
  const open = Boolean(anchorE2);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorE2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorE2(null);
  };

  return (
    <div>
      <div className={`menu-icon-button ${open && "hovered"}`}>
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className="menu-icon-button"
        >
          <MenuIcon />
        </IconButton>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorE2}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
      >
        <div className="action-menu-container">
          <div className="manage-section-dropdown-item cp mg-top-10">
            <ModeEditIcon className="manage-section-iconss" />
            <Link
              className="manage-section-dropdown-item-link"
              to={`/${navigationLink}/${rowData.id}`}
              onClick={(event) => event.stopPropagation()}
            >
              <p className="manage-small-popup-menuu1-p">Edit Details</p>
            </Link>
          </div>

          {!isGroupMenu && (
            <div
              className="manage-section-dropdown-item cp"
              onClick={(event) => {
                event.stopPropagation();
                openDialogResetPassword(rowData.email);
              }}
            >
              <KeyIcon className="manage-section-iconss" />
              <div className="manage-section-dropdown-item-link">
                <p className="manage-small-popup-menuu1-p">Reset Password</p>
              </div>
            </div>
          )}

          {!isGroupMenu && rowData.user.deleted === false && (
            <div
              className="manage-section-dropdown-item cp"
              onClick={(event) => {
                event.stopPropagation();
                openDialog(rowData.id);
              }}
            >
              <DeleteIcon className="manage-section-iconss delete-icon" />
              <div className="manage-section-dropdown-item-link">
                <p className="manage-small-popup-menuu1-p">Delete</p>
              </div>
            </div>
          )}

          {isGroupMenu && (
            <div
              className="manage-section-dropdown-item cp"
              onClick={(event) => {
                event.stopPropagation();
                openDialog(rowData.id);
              }}
            >
              <DeleteIcon className="manage-section-iconss delete-icon" />
              <div className="manage-section-dropdown-item-link">
                <p className="manage-small-popup-menuu1-p">Delete Group</p>
              </div>
            </div>
          )}
        </div>
      </Menu>
    </div>
  );
}
